export default __webpack_public_path__ + "static/media/8DEC8E73-EDDC-49C2-9506-9B7DD254B602_1_105_c.f9ee803a.jpeg";